<mds-dialog>
    <mds-dialog-content>
        <div class="o-grid">
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <h5>
                        Are you sure you want to delete this patient? If you proceed, all PHI associated with this
                        patient will be purged.
                    </h5>
                </div>
            </div>
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'center'">
        <div class="flex flex-row gap-medpace">
            <mds-button
                [id]="'yesBtn'"
                (clickEvent)="deleteConfirm()"
                [color]="'primary'"
                [variant]="'filled'"
                label="Yes"
                width="auto"
            ></mds-button>
            <mds-button
                [id]="'cancelBtn'"
                (clickEvent)="closeDialog()"
                [variant]="'outline'"
                label="Cancel"
                width="auto"
            ></mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
